import React, { useContext, useEffect } from "react";

import { popFrontURL } from "../../../utils/popFrontURL";
import { usePageLocalization } from "@sbi-international/boutik.gatsby.plugin.multilocale";
import { ServicesContext } from "@sbi-international/boutik.gatsby.plugin.services/dist/src/contexts/servicesContext";
import GatsbyImageWrapper from "../../GatsbyImageWrapper";
import { IProduct } from "@sbi-international/boutik.gatsby.plugin.services";
import { ProductPrice } from "../../price/ProductPrice";
import { ProductStock } from "@sbi-international/boutik.gatsby.plugin.components";

interface Product {
    code: string;
    slug: { [key: string]: string };
    fields: any;
    title: { [key: string]: string };
}

export function AccessorySingleSearch({ product }: { product: Product }) {
    const { navigateTranslated, currentLocale } = usePageLocalization();
    const [productData, setProductData] = React.useState<IProduct>();
    const navigateToVenting = (product: Product) => {
        if (product) {
            const link = popFrontURL(product?.slug?.[currentLocale], 1);
            if (link) {
                navigateTranslated(link);
            }
        }
    };

    const servicesContext = useContext(ServicesContext);
    const productService = servicesContext?.magento.productService;

    useEffect(() => {
        if (productService) {
            productService.operations.getProduct(product.code).then((productData) => {
                if (productData) {
                    setProductData(productData);
                }
            });
        }
    }, [product]);

    return (
        <div
            className="product search-venting"
            onClick={() => {
                navigateToVenting(product);
            }}
        >
            <div className="product-image">
                <GatsbyImageWrapper fields={product.fields} />
            </div>
            <div className="product-info">
                <span className="code">{product.code}</span>
                <span className="title">{product?.title?.[currentLocale]}</span>
                <ProductPrice
                    currentPrice={productData?.currentPrice}
                    prefixClassName="search-list-price"
                />
                <div className="search-list-price">
                    <ProductStock currentStock={productData?.currentStock} type="small" isCustomMade={false} />
                </div>
            </div>
        </div>
    );
}
